import { i18n } from "../../../i18n";
import router from '@/router'
import {fbFunctions} from "../../../config/firebase";
import firebase from "firebase/app";
const fb = require('@/config/firebase.js')

const state = () => ({
    formLogin: {
        email: "",
        password: ""
    },
    formForgot: {
        email: "",
    },
    formRegister: {
        email: "",
        password: "",
        passwordConfirm: "",
        agree: false,
    },
    error: {
        emailLogin: false,
        passwordLogin: false,
        emailForgot: false,
        emailRegister: false,
        passwordRegister: false,
        passwordRegisterConfirm: false,
    }
})

const getters = {}

const actions = {
    submitLogin({ commit, state }) {
        const vm = this;
        if (state.formLogin.email === null) commit('setErrorEmailLogin', true);
        if (state.formLogin.password === null) commit('setErrorPasswordLogin', true);
        if (!state.error.emailLogin && !state.error.passwordLogin) {
            fb.auth
                .signInWithEmailAndPassword(state.formLogin.email, state.formLogin.password)
                .then(user => {
                    router.push('/dashboard');
                })
                .catch(err => {
                    if (err.code === "auth/user-not-found") {
                        swal.fire(
                            i18n.t("login.error_user_not_found_title"),
                            i18n.t("login.error_user_not_found_subtitle"),
                            "error"
                        );
                    } else if (err.code === "auth/invalid-email") {
                        swal.fire(
                            i18n.t("login.error_invalid_email_title"),
                            i18n.t("login.error_invalid_email_subtitle"),
                            "error"
                        );
                    } else if (err.code === "auth/wrong-password") {
                        swal.fire(
                            i18n.t("login.error_invalid_password_title"),
                            i18n.t("login.error_invalid_password_subtitle"),
                            "error"
                        );
                    } else if (err.code === "auth/user-disabled") {
                        swal.fire(
                            i18n.t("login.error_user_disabled_title"),
                            i18n.t("login.error_user_disabled_subtitle"),
                            "error"
                        );
                    }
                });
        }
    },
    submitRegister({ commit, state }) {
        if(state.formRegister.email === null) commit('setErrorEmailRegister', true);
        if(state.formRegister.password === null) commit('setErrorPasswordRegister', true);
        if(state.formRegister.passwordConfirm === null) commit('setErrorPasswordConfirmRegister', true);

        if(state.formRegister.password !== state.formRegister.passwordConfirm) {
            swal.fire(
                i18n.t("login.error_password_confirm_mismatch_title"),
                i18n.t("login.error_password_confirm_mismatch_subtitle"),
                "error"
            );
        }

        if(state.formRegister.agree === false) {
            swal.fire(
                i18n.t("login.error_didnt_accepted_terms_title"),
                i18n.t("login.error_didnt_accepted_terms_subtitle"),
                "error"
            );
        }

        if(!state.error.emailRegister && (state.formRegister.password === state.formRegister.passwordConfirm) && state.formRegister.agree) {
            fb.auth
                .createUserWithEmailAndPassword(state.formRegister.email, state.formRegister.password)
                .then((result) => {
                    swal.fire({
                        title: i18n.t("login.account_creation_loading_title"),
                        text: i18n.t("login.account_creation_loading_content"),
                        onOpen: function() {
                            swal.showLoading()
                        }
                    });
                    let saveProfileInfos = fbFunctions.httpsCallable('api');
                    saveProfileInfos({
                        type: 'createUser',
                        parameters: {
                            'oAuth': false,
                        }
                    })
                    .then(function(cfResult) {
                        if(cfResult.data === "USER_CREATED") {
                            setTimeout(function () {
                                swal.close()
                                location.reload()
                            }, 2000);
                        }
                    })
                    .catch(function(e) {
                        console.log(e.toString());
                    });
                })
                .catch(err => {
                    if(err.code === "auth/weak-password") {
                        swal.fire(
                            i18n.t("login.error_password_weak_title"),
                            i18n.t("login.error_password_weak_subtitle"),
                            "error"
                        );
                    }
                    else if(err.code === "auth/email-already-in-use") {
                        swal.fire(
                            i18n.t("login.error_email_already_exists_title"),
                            i18n.t("login.error_email_already_exists_subtitle"),
                            "error"
                        );
                    }
                    else if(err.code === "auth/invalid-email") {
                        swal.fire(
                            i18n.t("login.error_invalid_email_title"),
                            i18n.t("login.error_invalid_email_subtitle"),
                            "error"
                        );
                    }
                });
        }
    },
    submitForgotPassword({ commit, state }) {
        if(state.formForgot.email === null) commit('setErrorEmailForgot', true);
        if(!state.error.emailForgot) {
            fb.auth
                .sendPasswordResetEmail(state.formForgot.email)
                .then((result) => {
                    swal.fire(
                        i18n.t('login.modal_success_forgot_password_title'),
                        i18n.t('login.modal_success_forgot_password_content'),
                        "success"
                    );
                })
                .catch(err => {
                    if(err.code === "auth/user-not-found") {
                        swal.fire(
                           i18n.t("login.error_user_not_found_title"),
                           i18n.t("login.error_user_not_found_subtitle"),
                            "error"
                        );
                    }
                    if(err.code === "auth/invalid-email") {
                        swal.fire(
                           i18n.t("login.error_invalid_email_title"),
                           i18n.t("login.error_invalid_email_subtitle"),
                            "error"
                        );
                    }
                });
        }
    },
    signInWithGoogle() {
        let vm = this;
        let provider = new firebase.auth.GoogleAuthProvider();
        fb.auth.signInWithPopup(provider)
            .then(function(result) {
                if(result.additionalUserInfo.isNewUser) {
                    swal.fire({
                        title: i18n.t("login.acount_loading_title"),
                        text: i18n.t("login.account_loading_content"),
                        onOpen: function() {
                            swal.showLoading()
                        }
                    });
                    let saveProfileInfos = fbFunctions.httpsCallable('api');
                    saveProfileInfos({
                        type: 'createUser',
                        parameters: {
                            'oAuth': true,
                        }
                    })
                    .then(function(cfResult) {
                        if(cfResult.data === "USER_CREATED") {
                            setTimeout(function () {
                                swal.close()
                                location.reload()
                            }, 2000);
                        }
                        else if(cfResult.data === "USER_ALREADY_EXISTS") {
                            swal.close()
                            router.push('dashboard')
                        }
                    })
                    .catch(function(e) {
                        console.log(e.toString());
                    });
                }
                else router.push('dashboard')
            })
            .catch(function(error) {

            });
    },

    /**
     * Handle signin with Apple
     */
    signInWithApple() {
        let vm = this;
        let provider = new firebase.auth.OAuthProvider('apple.com');
        fb.auth.signInWithPopup(provider)
            .then(function(result) {
                if(result.additionalUserInfo.isNewUser) {
                    swal.fire({
                        title: i18n.t("login.acount_loading_title"),
                        text: i18n.t("login.account_loading_content"),
                        onOpen: function() {
                            swal.showLoading()
                        }
                    });
                    let saveProfileInfos = fbFunctions.httpsCallable('api');
                    saveProfileInfos({
                        type: 'createUser',
                        parameters: {
                            'oAuth': true,
                        }
                    })
                    .then(function(cfResult) {
                        if(cfResult.data === "USER_CREATED") {
                            setTimeout(function () {
                                swal.close()
                                location.reload()
                            }, 2000);
                        }
                        else if(cfResult.data === "USER_ALREADY_EXISTS") {
                            swal.close()
                            router.push('dashboard')
                        }
                    })
                    .catch(function(e) {
                        console.log(e.toString());
                    });
                }
                else $router.push('dashboard')
            })
            .catch(function(error) {
                console.log(error);
            });
    }
}

const mutations = {
    setFormLoginInput(state, val) {
        state.formLogin[val.fieldToEdit] = val.fieldToEditValue;
    },
    setFormRegisterInput(state, val) {
        state.formRegister[val.fieldToEdit] = val.fieldToEditValue;
    },
    setFormForgotEmail(state, val) {
        state.formForgot[val.fieldToEdit] = val.fieldToEditValue;
    },
    setErrorEmailLogin(state, val) {
        state.error.emailLogin = val;
    },
    setErrorPasswordLogin(state, val) {
        state.error.passwordLogin = val;
    },
    setErrorEmailRegister(state, val) {
        state.error.emailRegister = val;
    },
    setErrorPasswordRegister(state, val) {
        state.error.passwordRegister = val;
    },
    setErrorPasswordConfirmRegister(state, val) {
        state.error.passwordRegisterConfirm = val;
    },
    setErrorEmailForgot(state, val) {
        state.error.emailForgot = val;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/stores/modules/pages/login.js